import { apiRequest } from "./api";

export type TransportStopRecord = {
    id: string;
    organization_id: string;
    name: string;
    latitude: number | null;
    longitude: number | null;
    created_at: string;
    updated_at: string;
};

export type TransportStopPayload = {
    name: string;
    latitude?: number | null;
    longitude?: number | null;
};

export async function fetchTransportStops(): Promise<TransportStopRecord[]> {
    const res = await apiRequest<TransportStopRecord[]>('/api/transport-stops');
    return res.data;
}

export async function createTransportStop(payload: TransportStopPayload) {
    const res = await apiRequest('/api/transport-stops', {
        method: 'POST',
        body: JSON.stringify(payload),
    });
    return res;
}
